var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcThreeDotHorizontal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "21px",
    viewBox: "0 0 6 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-chat-New-designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo-preview-big",
    transform: "translate(-353.000000, -45.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(353.500000, 45.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,17.5 C5,18.88025 3.88075,20 2.5,20 C1.11925,20 0,18.88025 0,17.5 C0,16.11925 1.11925,15 2.5,15 C3.88075,15 5,16.11925 5,17.5 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,10 C5,11.38025 3.88075,12.5 2.5,12.5 C1.11975,12.5 0,11.38025 0,10 C0,8.61925 1.11975,7.5 2.5,7.5 C3.88075,7.5 5,8.61925 5,10 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0 C3.88075,0 5,1.11925 5,2.5 C5,3.88025 3.88075,5 2.5,5 C1.11975,5 0,3.88025 0,2.5 C0,1.11925 1.11975,0 2.5,0",
    id: "Fill-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThreeDotHorizontal);
export default __webpack_public_path__ + "static/media/icThreeDotHorizontal.8b9a08a8e0f5b1df3c8c4cc2a1044721.svg";
export { ForwardRef as ReactComponent };